<template>
  <div v-loading.fullscreen.lock="loading">
    <div class="container-fluid sinup-container">
      <div class="row window-hight">
        <div class="col-12 col-md-6 left-bg">
          <div class="inner-left-wrap p-2 p-md-5">
            <a href="https://homeoftraining.com" class="navbar-brand mb-3 mb-md-5">
              <img src="/signup-img/hot-logo.webp" width="186"  />
            </a>

            <!-- <div class="alert alert-dark " role="alert">
              Welcome to our brand new platform design. We want to hear your thoughts! Any questions or comments feel free to reach out to <a href="mailto:support@homeoftraining.com" style="color: white;text-decoration: underline;">support@homeoftraining.com</a>
            </div> -->

            <div class="signin-header pt-3">
              <h3 class="mb-0">Sign In <img src="/signup-img/fire.svg" alt=""></h3>
              <span class="d-block mb-4">Welcome back! </span>
            </div>
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <base-input alternative class="mb-3 login-input singup-input" name="Username"
                  :rules="{ required: true }" placeholder="Email Address" v-model="form.username">
                </base-input>
                <div class="pass-wrap position-relative">
                  <base-input alternative class="mb-3 login-input position-relative singup-input" name="Password"
                    :rules="{ required: true }" :type="passwordFieldType" placeholder="Password"
                    v-model="form.password">

                  </base-input>
                  <span class="eye-icon-pass" @click="togglePasswordVisibility">
                    <img v-if="passwordFieldType === 'password'" src="/img/svg-icons/eye-cut-icon.svg"
                      alt="Hide Password" />
                    <img v-else src="/img/svg-icons/eye-icon.svg" alt="Show Password" />
                  </span>
                  <!-- <span  @click="showPassword()"><img src="/img/svg-icons/eye-icon.svg" alt="" /></span> -->
                </div>

                <div class="row my-4">
                  <div class="col-6 col-md-6">
                    <label class="chk-container">Remember me
                      <input type="checkbox">
                      <span class="checkmark"></span>
                    </label>
                  </div>
                  <div class="col-6 col-md-6">
                    <div class="text-right forget-txt">
                      <router-link to="/forget_password">Forgot Password?
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center signinbtn mb-4">
                  <base-button native-type="submit" class="d-block w-100 mb-1 mb-md-0">Sign In
                    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M17.5467 10.9333C17.2401 10.5333 16.8667 10.1867 16.5201 9.84C15.6267 9.04 14.6134 8.46667 13.7601 7.62667C11.7734 5.68 11.3334 2.46667 12.6001 0C11.3334 0.306667 10.2267 1 9.28007 1.76C5.82673 4.53333 4.46673 9.42667 6.0934 13.6267C6.14673 13.76 6.20007 13.8933 6.20007 14.0667C6.20007 14.36 6.00007 14.6267 5.7334 14.7333C5.42673 14.8667 5.10673 14.7867 4.8534 14.5733C4.77773 14.5099 4.71444 14.4331 4.66673 14.3467C3.16007 12.44 2.92007 9.70667 3.9334 7.52C1.70673 9.33333 0.4934 12.4 0.666733 15.2933C0.746733 15.96 0.826733 16.6267 1.0534 17.2933C1.24007 18.0933 1.60007 18.8933 2.00007 19.6C3.44007 21.9067 5.9334 23.56 8.6134 23.8933C11.4667 24.2533 14.5201 23.7333 16.7067 21.76C19.1467 19.5467 20.0001 16 18.7467 12.96L18.5734 12.6133C18.2934 12 17.5467 10.9333 17.5467 10.9333ZM13.3334 19.3333C12.9601 19.6533 12.3467 20 11.8667 20.1333C10.3734 20.6667 8.88007 19.92 8.00007 19.04C9.58673 18.6667 10.5334 17.4933 10.8134 16.3067C11.0401 15.24 10.6134 14.36 10.4401 13.3333C10.2801 12.3467 10.3067 11.5067 10.6667 10.5867C10.9201 11.0933 11.1867 11.6 11.5067 12C12.5334 13.3333 14.1467 13.92 14.4934 15.7333C14.5467 15.92 14.5734 16.1067 14.5734 16.3067C14.6134 17.4 14.1334 18.6 13.3334 19.3333Z"
                        fill="white" />
                    </svg>

                  </base-button>
                </div>
              </form>
              <!-- <router-link to="/signup" class="text-light"
                            ><h3 class="text-center pb-4" style="color:#13b6e7;">
                              Not a customer?
                            </h3></router-link
                          > -->
              <div class="row">
                <div class="col-12">
                  <div class="text-center d-flex justify-content-center singup-option align-items-center">
                    <p class="mb-0 pr-1">Need an account?</p>
                    <router-link to="/pricing" class="underline-class">Sign Up Here
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12">
                  <div class="text-center d-flex justify-content-center singup-option align-items-center">
                    <a @click.prevent="showModal()" class="underline-class" style="cursor: pointer;">
                      Report an Issue?
                    </a>
                  </div>
                </div>
              </div>
              <p class="error" v-if="errors.invalid">{{ errors.invalid }}</p>
            </validation-observer>
          </div>
        </div>
        <div class="col-12 col-md-6 right-bg">
          <div class="inner-right-wrap d-flex flex-column h-100 pt-5 pl-2 pl-md-5">
            <h2 class="text-white mb-2 mb-md-0">Manage Your System!</h2>
            <p class="text-white mb-5">Enter your credentials to unlock our interactive learning dashboard.</p>
            <div class="img-wrap d-flex justify-content-end mt-auto">
              <img class="img-fluid" src="signup-img/admin-img.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
        <modal :show.sync="showReportModal" class="">
           <h3 slot="header" class="title title-up text-primary">
          Report an Issue or Share Feedback
      </h3>
       <small>
        <strong>
          If you’ve encountered a problem or have suggestions to improve your experience, please let us know. Your input helps us serve you better.
        </strong>
      </small>
        <div class="row mt-2">
        <div class="col-md-12">
          <!-- Name Input -->
          <div class="form-group">
            <label>Name</label>
            <input
              type="text"
              v-model="account.name"
              placeholder="Name"
              class="form-control"
            />
          </div>

          <!-- Email Input (readonly) -->
          <div class="form-group">
            <label>Email</label>
            <input
              type="email"
              v-model="account.email"
              placeholder="Email"
              class="form-control"
            />
          </div>

          <!-- Native Select Dropdown -->
          <!-- <div class="form-group">
            <label>Select Issue</label>
            <select v-model="account.issue" class="form-control">
              <option disabled value="">Please select one</option>
              <option
                v-for="item in feedbackCategories"
                :key="item.key"
                :value="item.value"
              >
                {{ item.value }}
              </option>
            </select>
          </div> -->

              <base-input label="Select Issue">
            <el-select class="select-primary" v-model="account.issue" placeholder="Select Issue"
              v-on:change="changePage(1)">
              <el-option class="select-primary" v-for="item in feedbackCategories" :key="item.key" :label="item.value"
                :value="item.value">
              </el-option>
            </el-select>
          </base-input>

          <div class="form-group">
            <label>Comments</label>
            <textarea
              v-model="account.comments"
              placeholder="Enter your comments here..."
              class="form-control"
              rows="4"
            ></textarea>
          </div>
          <div class="text-right">
            <base-button
              class="greybtn"
              outline
              @click="hideModal()"
            >
              Close
            </base-button>
            <base-button
              type="primary"
              @click="submitData()"
            >
              Submit
            </base-button>
        </div>
      </div>
        </div>

    </modal>

  </div>
</template>
<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { Option, Select, Table, TableColumn } from 'element-ui'


export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      showReportModal : false,

       feedbackCategories: [
        { key: 'general_feedback', value: 'General Feedback' },
        { key: 'logging_in', value: 'Logging In' },
        { key: 'course_taking', value: 'Course Taking' },
        { key: 'course_assigning', value: 'Course Assigning' },
        { key: 'user_creation_updating', value: 'User Creation/Updating' },
        { key: 'location_creation_updating', value: 'Location Creation/Updating' },
        { key: 'platform_not_working', value: 'Platform Not Working' },
        { key: 'other', value: 'Other' }
      ],
      account: {
        name: "",
        email: "",
        issue: "",
        comments: '',
      },
      loading: false,
      form: {
        username: "",
        password: ""
      },
      passwordFieldType: "password",
      errors: {
        invalid: ""
      }
    };
  },
  created: function () {
    if (this.$route.query.email && this.$route.query.password) {
      this.form.username = this.$route.query.email;
      this.form.password = this.$route.query.password;
      this.onSubmit();
    }
  },
  methods: {

submitData() {
  this.$http
    .post("support", {
      name: this.account.name,
      email: this.account.email,
      issue: this.account.issue,
      comments: this.account.comments,
    })
    .then((resp) => {
      Swal.fire({
        icon: 'success',
        title: 'Message Sent',
        text: resp.data.message || 'Your support request was sent successfully!',
      });
      this.account = {
        name: "",
        email: "",
        issue: "",
        comments: ''
      };
      this.hideModal();
    })
    .catch((error) => {
      let errorText = "Something went wrong. Please try again.";

      // Laravel validation error (422)
      if (error.response && error.response.status === 422) {
        if (typeof error.response.data.errors === 'object') {
          const messages = Object.values(error.response.data.errors)
            .flat()
            .join('\n');
          errorText = messages;
        } else if (error.response.data.message) {
          errorText = error.response.data.message;
        }
      }

      // Laravel general error
      else if (error.response && error.response.data && error.response.data.message) {
        errorText = error.response.data.message;
      }

      Swal.fire({
        icon: 'error',
        title: 'Submission Failed',
        text: errorText,
      });
    });
},

    showModal() {
      this.showReportModal = true;
    },
    hideModal() {
      this.showReportModal = false;
    },
    redirectAfterLogin() {
      if (sessionStorage.getItem("certificate_download_target")) {
        this.$router.push("/certificate-access");
        return;
      }
      const redirectPath = localStorage.getItem("redirect-path");
      if (redirectPath && redirectPath === "/payment-information") {
        this.$router.push(redirectPath);
        return;
      }
      this.$router.push("/dashboard");
    },
    onSubmit() {
      this.loading = true;
      this.$http
      .post("user/login", {
        email: this.form.username,
        password: this.form.password
      })
      .then(resp => {
        localStorage.setItem("hot-token", resp.data.token);
        localStorage.setItem("hot-email", resp.data.email);

        localStorage.setItem("hot-user", resp.data.role);
        localStorage.setItem("hot-logged-user", resp.data.user_id);
        localStorage.setItem("hot-user-full-name", resp.data.full_name);
        localStorage.setItem("other-company-login", "login");
        let headers = {
        authorization: "Bearer " + resp.data.token,
        "content-type": "application/json"
        };
        this.$http.defaults.headers.authorization =
        "Bearer " + resp.data.token;
        let admin = "";
        let level = "";

        switch (resp.data.role) {
        case "super-admin":
          admin = "super_admin";
          localStorage.setItem("hot-sidebar", admin);
          this.$http
          .post(
            "company/managerdata",
            {
            email: this.form.username
            },
            { headers }
          )
          .then(resp => {
            localStorage.setItem("hot-user-id", resp.data[0].id);
            this.redirectAfterLogin();
          });

          break;
        case "company-admin":
          admin = "admin";
          localStorage.setItem("hot-sidebar", admin);
          this.$http
          .post(
            "company/data",
            {
            email: this.form.username
            },
            { headers }
          )
          .then(resp => {
            if (resp.data.level) {
            localStorage.setItem("hot-company-level", "parent");
            } else {
            localStorage.setItem("hot-company-level", "child");
            }
            localStorage.setItem("hot-admin-id", resp.data.admin_id);
            localStorage.setItem("hot-user-id", resp.data[0].id);
            localStorage.setItem("hot-company-name", resp.data[0].name);
            this.redirectAfterLogin();
          });
          break;
        case "manager":
          admin = "manager";
          localStorage.setItem("hot-sidebar", admin);
          this.$http
          .post(
            "company/managerdata",
            {
            email: this.form.username
            },
            { headers }
          )
          .then(resp => {
            localStorage.setItem("hot-user-id", resp.data.user.id);
            localStorage.setItem("hot-admin-id", resp.data.company_id);
            localStorage.setItem("hot-user-name", resp.data.user.full_name);
            localStorage.setItem(
            "hot-user-number",
            resp.data.user.phone_num
            );
            localStorage.setItem(
            "hot-user-2fa",
            resp.data.user.is_2f_authenticated
            );
            this.redirectAfterLogin();
          });
          break;
        case "employee":
          admin = "employee";
          localStorage.setItem("hot-sidebar", admin);
          this.$http
          .post(
            "employees/user_data",
            {
            user_name: this.form.username
            },
            { headers }
          )
          .then(resp => {
            localStorage.setItem("hot-user-id", resp.data[0].id);
            localStorage.setItem("hot-user-name", resp.data[0].full_name);
            localStorage.setItem(
            "hot-user-number",
            resp.data[0].phone_num
            );
            localStorage.setItem(
            "hot-user-2fa",
            resp.data[0].is_2f_authenticated
            );
            if (resp.data[0].employee_status == 0) {
            this.errors.invalid = "Account is Deactivated by Admin..!!";
            } else {
            this.redirectAfterLogin();
            }
          });
          break;
        case "sub-admin":
          admin = "sub_admin";
          localStorage.setItem("hot-sidebar", admin);
          this.$http
          .post(
            "company/managerdata",
            {
            email: this.form.username
            },
            { headers }
          )
          .then(resp => {
            localStorage.setItem("hot-user-id", resp.data[0].id);
            this.redirectAfterLogin();
          });

          break;
        default:
          this.errors.invalid = "Not Valid..!!";
        }
      })
      .catch(function (error) {
        let errorText = "Something went wrong! Please try again later.";
        if (error.response && error.response.status === 422) {
        errorText = error.response.data.message;
        }
        if (error.response && error.response.data.is_company_active === false) {
        self.processing = false;
        Swal.fire({
          title: "Account Inactive",
          html: "The company you were assigned to is inactive. Click Proceed to be transferred to an individual account where you can take courses and have access to your certificates.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Proceed",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
          this.$http
            .post(
            "user/transfer",
            {
              email: this.form.username
            },
            )
            .then((response) => {
            Swal.fire({
              title: "Success!",
              text: "You have been successfully moved to an individual account.",
              icon: "success",
            });
            })
            .catch((err) => {
            Swal.fire({
              title: "Error!",
              text: "Failed to proceed. Please try again later.",
              icon: "error",
            });
            });
          }
        });
        return;
        } else if (error.response && error.response.data.company_user_active === false) {
        Swal.fire({
          title: "Account Inactive",
          html: error.response.data.message,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed) {
          this.$http
            .post(
            "user/active-user",
            {
              email: this.form.username
            },
            )
            .then((response) => {
            Swal.fire({
              title: "Success!",
              text: "Your account is reactivated",
              icon: "success",
            });
            })
          } else {
          Swal.fire({
            title: "Account Inactive",
            html: "Would you like to proceed with an individual account?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Convert to Individual Account",
            cancelButtonText: "Cancel",
          }).then((result) => {
            if (result.isConfirmed) {
            this.$http
              .post(
              "user/active-and-transfer-user",
              {
                email: this.form.username
              },
              ).then((response) => {
              Swal.fire({
                title: "Success!",
                text: "Your account is reactivated as Individual User",
                icon: "success",
              });
              })
            }
          });
          }
        });
        } else {
        Swal.fire({
          title: "Error!",
          html: errorText,
          icon: "error"
        });
        }
      }.bind(this))
      .finally(() => (this.loading = false));
    },
    togglePasswordVisibility() {
      // Toggle between 'password' and 'text'
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
  }
};
</script>
<style scoped>
::v-deep select.form-control,
::v-deep select.form-control option {
  font-family: "Inter", serif;
}
body,
html {
  height: 100%;
}

.form-section {
  background-color: #e4e8e8;
}

.login-section {
  background-color: #ececf9;
  padding: 0px;
}

.course-section {
  background-color: #ffffff !important;
  padding: 40px;
}

.error {
  color: red;
  text-align: center;
}

.py-5 {
  padding-bottom: 0px !important;
}

.mt--10 {
  margin-top: -10rem !important;
}

.user-icon {
  font-size: 10rem;
  padding-bottom: 1.3rem;
  color: #28c0e7;
}

.user-icon-company {
  font-size: 11.2rem;
  padding-bottom: 0;
  color: #28c0e7;
}

.singup-option {
  /* display: flex;
    justify-content: flex-end; */
  font-size: 15px;
}

.singup-option a {
  color: #1e1e1e;
  font-weight: 500;
}

.btn.custom-btn {
  background-color: #80d610;
  border-color: #80d610;
}

.left-bg {
  background: #f3f3f3 url("/signup-img/signup_bg1.svg") no-repeat right bottom;

}

.right-bg {
  background: url("/signup-img/signup_bg2.svg") no-repeat center center;
  background-size: cover;
}

.img-wrap {
  margin-right: -15px;
}

html,
body,
.window-hight {
  height: 100vh;
  /* overflow: hidden; */
}

.sinup-container {
  font-family: "Inter", serif;
  color: #1e1e1e;
}

.signin-header h3 {
  font-size: 40px;
  font-weight: 500;
  color: #1e1e1e;
  line-height: 50px;
}

.signin-header h3 img {
  margin-top: -13px;
}

.chk-container {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 0;
  color: #656565;
  cursor: pointer;
  font-size: 15px !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.chk-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.chk-container .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #E8E7E7;
  border: 1px solid #D2CECE;
}


/* On mouse-over, add a grey background color */


/* When the checkbox is checked, add a blue background */
.chk-container input:checked~.checkmark {
  background-color: #FE672C;
  border-color: #FE672C;
}

/* Create the checkmark/indicator (hidden when not checked) */
.chk-container .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.chk-container input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.chk-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.forget-txt a {
  font-size: 15px;
  color: #FE672C;
  font-weight: 500;
  border-bottom: 1px solid #FE672C;
}

.forget-txt a:hover {
  border-bottom: 0;
}

.signinbtn .btn {
  background: linear-gradient(to bottom, #e48e39 0%, #ea2628 100%);
  border: 0;
  height: clamp(40px, 6vw, 60px);        /* Scales between 40px-60px */
  font-size: clamp(20px, 2.5vw, 25px);  /* Scales between 16px-25px */
  font-weight: normal;
  transform: none;
}
.signinbtn .btn:hover {
  opacity: .8;
}

.signinbtn .btn svg {
  margin-top: -4px;
}

.inner-right-wrap h2 {
  font-size: 50px;
  font-weight: 500;
}

.inner-right-wrap p {
  font-size: 20px;
  max-width: 70%;
}

@media (max-width: 767px) {
  .singup-input .form-control {
    height: 50px !important;
  }

  .signinbtn .btn {
    height: 50px;
  }

  .inner-right-wrap h2 {
    font-size: 30px;
  }

  .inner-right-wrap p {
    font-size: 18px;
    max-width: 100%;
  }
}
</style>
